import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#343434\" d=\"m12.028 1.2-.145.492v14.279l.145.144 6.628-3.917L12.028 1.2Z\"></path><path fill=\"#8C8C8C\" d=\"M12.028 1.2 5.4 12.198l6.628 3.917V1.2Z\"></path><path fill=\"#3C3C3B\" d=\"m12.028 17.37-.082.1v5.086l.082.238 6.632-9.34-6.632 3.916Z\"></path><path fill=\"#8C8C8C\" d=\"M12.028 22.794V17.37L5.4 13.454l6.628 9.34Z\"></path><path fill=\"#141414\" d=\"m12.028 16.115 6.628-3.917-6.628-3.013v6.93Z\"></path><path fill=\"#393939\" d=\"m5.4 12.198 6.628 3.917v-6.93L5.4 12.198Z\"></path>", 6)
  ])))
}
export default { render: render }